import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateHostelRoom from "../../../../Controllers/Admin/Hostel/CreateHostelRoom";
import GetSingleHostelRoom from "../../../../Controllers/Admin/Hostel/GetSingleHostelRoom";
import UpdateHostelRoom from "../../../../Controllers/Admin/Hostel/UpdateHostelRoom";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function AddRoomViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [SchoolID, setSchoolID] = useState("");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [RoomID, setRoomID] = useState("");

  const [AuthUser, setAuthUser] = useState("");

  const [HostelNameError, setHostelNameError] = useState(false);
  const [RoomNumberError, setRoomNumberError] = useState(false);
  const [RoomTypeError, setRoomTypeError] = useState(false);
  const [TotalBedsError, setTotalBedsError] = useState(false);
  const [BedsAvailableError, setBedsAvailableError] = useState(false);
  const [CostPerBedError, setCostPerBedError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddRoom, setAddRoom] = useState({
    HostelName: "",
    Block: "",
    RoomNumber: "",
    RoomType: "",
    TotalBeds: 0,
    BedsAvailable: 0,
    CostPerBed: 0,
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setRoomID(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const RoomData = await GetSingleHostelRoom(RoomID);
        setAddRoom({
          HostelName: RoomData?.HostelName,
          Block: RoomData?.Block,
          RoomNumber: RoomData?.RoomNumber,
          RoomType: RoomData?.RoomType,
          TotalBeds: RoomData?.TotalBeds,
          BedsAvailable: RoomData?.BedsAvailable,
          CostPerBed: RoomData?.CostPerBed,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, RoomID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddRoom.HostelName === "" ||
      AddRoom.HostelName === null ||
      AddRoom.HostelName === undefined ||
      AddRoom.HostelName.length < 3
    ) {
      setHostelNameError(true);
      flag++;
    } else {
      setHostelNameError(false);
    }

    if (
      AddRoom.RoomNumber === "" ||
      AddRoom.RoomNumber === null ||
      AddRoom.RoomNumber === undefined
    ) {
      setRoomNumberError(true);
      flag++;
    } else {
      setRoomNumberError(false);
    }

    if (
      AddRoom.RoomType === "" ||
      AddRoom.RoomType === null ||
      AddRoom.RoomType === undefined
    ) {
      setRoomTypeError(true);
      flag++;
    } else {
      setRoomTypeError(false);
    }

    if (
      AddRoom.TotalBeds === "" ||
      AddRoom.TotalBeds === null ||
      AddRoom.TotalBeds === undefined ||
      AddRoom.TotalBeds <= 0
    ) {
      setTotalBedsError(true);
      flag++;
    } else {
      setTotalBedsError(false);
    }

    if (
      AddRoom.BedsAvailable === "" ||
      AddRoom.BedsAvailable === null ||
      AddRoom.BedsAvailable === undefined ||
      AddRoom.BedsAvailable < 0
    ) {
      setBedsAvailableError(true);
      flag++;
    } else {
      setBedsAvailableError(false);
    }

    if (AddRoom.CostPerBed <= 0) {
      setCostPerBedError(true);
      flag++;
    } else {
      setCostPerBedError(false);
    }

    return flag;
  }, [
    AddRoom.HostelName,
    AddRoom.RoomNumber,
    AddRoom.RoomType,
    AddRoom.TotalBeds,
    AddRoom.BedsAvailable,
    AddRoom.CostPerBed,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterRoom = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const RoomFinalObject = {
          ...AddRoom,
        };

        await UpdateHostelRoom(RoomFinalObject, RoomID)
          .then(() => {
            ToastSuccessMessages("hostel/update-successful");
            navigate("/user/admin/hostel");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const RoomFinalObject = {
          ...AddRoom,
        };

        await CreateHostelRoom(RoomFinalObject, AuthUser?.uid, SchoolID)
          .then(() => {
            ToastSuccessMessages("hostel/add-successful");
            navigate("/user/admin/hostel");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterRoom,
    AddRoom,
    setAddRoom,
    HostelNameError,
    RoomNumberError,
    RoomTypeError,
    TotalBedsError,
    BedsAvailableError,
    CostPerBedError,
    FormDisabled,
    IsUpdate,
  };
}
